import { Empty, Icon } from 'ui';
import { useDebounce } from 'common/hooks';
import { EntityList } from 'features/channels';
import { useCommunitiesInfiniteQuery } from '../../../queries';

type P = {
  getPathToCommunityDetail: (id: string) => string;
  search?: string;
};

const JoinedCommunitiesListContent = ({ getPathToCommunityDetail, search: propertySearch }: P) => {
  const { isDebouncing, value: search } = useDebounce(propertySearch);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useCommunitiesInfiniteQuery({
    filter: { scope: 'joined', search },
    pagination: { pageSize: 12 },
  });

  const communities = data?.pages.flat().flatMap((communitiesPaginated) => communitiesPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no communities to display here',
            title: 'No communities',
          }}
          image={<Icon icon="classify-2-line" />}
        />
      }
      entities={communities?.map((community) => ({
        data: community,
        type: 'Community',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToCommunityDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isDebouncing || isLoading}
    />
  );
};

export default JoinedCommunitiesListContent;
